import React, { useRef, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import BatchBooking from "./BatchBooking";
import { RecentBatchPrint } from "./RecentBatchPrint";
import PropTypes from "prop-types";

const BatchGroup = (props) => {
  const {
    selectedData,
    setShowCreateBatchDialog,
    setSelectedBatch,
    setSelectedData,
    gridData,
    createdBy,
    getAllRecords,
    setRate,
    thresholdValidation,
  } = props;
  const dispatch = useDispatch();
  const ref = useRef();
  const { batchesList } = useSelector((state) => state.batchReducer);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let data;
    if (batchesList?.length) {
      data = batchesList.map((item) => {
        return {
          ...item,
          id: item.orderBatchId,
          label: item.orderBatchName,
        };
      });
      setOptions(data);
    } else {
      setOptions([]);
    }
  }, [batchesList?.length]);

  const handleSearch = (query) => {
    setSelectedData([]);
    setSelectedBatch(query);
    ref.current.blur();
  };

  const handleOptions = (option) => {
    return (
      <div className="menuItemWrapper" key={option.id}>
        <div className="label">{option.label}</div>
      </div>
    );
  };

  return (
    <div className="bookingSection rightWidgetArea">
      <div className="create-batch batchBooking mt-0">
        <div className="batch-select fontFix">
          <div className="headingBatch">Select Batch Group </div>
          <Typeahead
            renderMenuItemChildren={handleOptions}
            id="batch"
            options={options}
            onChange={handleSearch}
            placeholder="Select Batch from list"
            clearButton
            className="batchListing"
            ref={ref}
          />
        </div>
        <div className="bookingWrapper">
          <Button
            onClick={() => setShowCreateBatchDialog(true)}
            variant="outline-primary"
            disabled={selectedData.length === 0}
            className={`${selectedData.length === 0
              ? "batchBookingBtn booking disabled"
              : "batchBookingBtn booking"
              }`}
          >
            {selectedData.length ? (
              <>Add {selectedData.length} Orders to Batch</>
            ) : (
              <>No Order Selected</>
            )}
          </Button>
          <BatchBooking
            {...props}
            selectedData={selectedData}
            setRate={setRate}
            thresholdValidation={thresholdValidation}
            gridData={gridData}
            createdBy={createdBy}
            getAllRecords={getAllRecords}
          />
          <RecentBatchPrint
            dispatch={dispatch}
            className="create-batch batchBooking"
            userDetails={createdBy}
          />
        </div>
      </div>
      <p className="warningHelperText mb-0">Note: Shipping labels are stored for 4 months only. Please download and store a copy for your records.</p>
    </div>
  );
};

BatchGroup.propTypes = {
  selectedData: PropTypes.array.isRequired,
  setShowCreateBatchDialog: PropTypes.func.isRequired,
  setSelectedBatch: PropTypes.func.isRequired,
  setSelectedData: PropTypes.func.isRequired,
  gridData: PropTypes.array.isRequired,
  createdBy: PropTypes.object.isRequired,
  getAllRecords: PropTypes.func.isRequired,
  setRate: PropTypes.func.isRequired,
  thresholdValidation: PropTypes.array.isRequired,
};

export default BatchGroup;
